"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _react = require("@xstate/react");
var _framerMotion = require("framer-motion");
var _propTypes = require("prop-types");
var _react2 = _interopRequireWildcard(require("react"));
var _constants = require("../../lib/constants");
var _DOBInput = require("./controls/DOBInput");
var _SingleChoiceButtons = require("./controls/SingleChoiceButtons");
var _ClinicalSearch = require("./controls/ClinicalSearch");
var _machine = require("./machine");
var _styles = require("./styles");
var _WarningBanner = require("./WarningBanner");
var _Loading = require("./Loading");
var _SearchAltProviderButton = _interopRequireDefault(require("./controls/SearchAltProvider/SearchAltProviderButton"));
var _utils = require("../../lib/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*eslint-disable react/display-name */

/**
 * @typedef TemplateVariables
 * @property {string} provider_name
 * @property {string} provider_state
 * @property {string} phone_number
 */

/**
 * @typedef PreviousAnswer
 * @property {string} answer User's answer to GX question
 * @property {number} node_id Step node `id`g
 * @property {number} protocol_id Step `flowId`
 */

/**
 * @typedef ExternalContext Data sent in query param `context` in `POST` req to GX API `/api/gx/protocol/${protocolId}/node/${stepId}`
 * @property {string} [clinical_keyword]
 * @property {string} [curren_section]
 * @property {string} [clinical_keyword]
 * @property {PreviousAnswer[]} [previous_answers]
 */

/**
 * @typedef Step
 * @property {number} id Step node id aka `node_id`
 * @property {number} flowId Step flow id aka `protocol_id`
 * @property {string} answer User's answer to GX question
 * @property {boolean} [sendToEHR] If true, then the question-answer should be sent to Scheduling upon booking the appointment. The `sendToEHR` property is "optional" becuase it may not exist on any GX question sets created before the GX API added the `sendToEHR` property.
 * @property {{path?: "patient.dob"}} control Object w/properties describing the question's controls.
 */

const {
  pending
} = _constants.states;
const {
  ANSWER
} = _constants.events;
const {
  init,
  warning,
  done,
  error,
  skipped
} = _constants.states;

// Smoothly transition the opacity attribute as questions are loaded in
const variants = {
  initial: {
    opacity: 0,
    transition: {
      opacity: {
        ease: _constants.Easing.easeInOutQuint
      }
    }
  },
  enter: {
    opacity: 1,
    transition: {
      opacity: {
        ease: _constants.Easing.easeInOutQuint
      }
    }
  }
};

/**
 * @param {number} protocolId
 * @param {string} currentState
 * @param {Step} step
 * @param {function} onChange
 * @param {TemplateVariables} templateVariables
 * @returns {JSX.Element|null}
 */
const renderByControlType = (protocolId, currentState, step, onChange, templateVariables, productName) => {
  const {
    control
  } = step;
  if (!control) return null;
  const {
    type
  } = control;
  const controlTypes = {
    [_constants.uiControls.DOB]: () => /*#__PURE__*/_react2.default.createElement(_DOBInput.DOBInput, {
      step: step,
      currentState: currentState,
      onChange: onChange,
      templateVariables: templateVariables
    }),
    [_constants.uiControls.SINGLE_CHOICE_BUTTONS]: () => /*#__PURE__*/_react2.default.createElement(_SingleChoiceButtons.SingleChoiceButtons, {
      step: step,
      currentState: currentState,
      onChange: onChange,
      templateVariables: templateVariables
    }),
    [_constants.uiControls.CLINICAL_SEARCH]: () => /*#__PURE__*/_react2.default.createElement(_ClinicalSearch.ClinicalSearch, {
      step: step,
      currentState: currentState,
      onChange: onChange,
      templateVariables: templateVariables,
      protocolId: protocolId,
      productName: productName
    })
  };
  return controlTypes[type] ? controlTypes[type]() : null;
};

/**
 * Guide Experience (GX) renderer
 * @param {string} csrfToken
 * @param {string} providerId
 * @param {string} name
 * @param {Step[]} steps
 * @param {ExternalContext} [externalContext]
 * @param {function} onChange
 * @param {function} onDone
 * @param {JSX.Element} catchAllErrorBanner
 * @param {string} [className]
 * @param {object} [config]
 * @param {string} [machineProps]
 * @returns {JSX.Element}
 */
const GxNext = _ref => {
  var _context3, _context4;
  let {
    csrfToken,
    providerId,
    name,
    steps: initSteps,
    externalContext,
    onChange,
    onDone,
    templateVariables,
    catchAllErrorBanner,
    className,
    config,
    productName,
    machineProps: inputMachineProps = {},
    searchMatchEnabled = false,
    track
  } = _ref;
  const machineProps = {
    config,
    productName,
    providerId,
    csrfToken,
    steps: initSteps,
    externalContext,
    ...inputMachineProps
  };
  const machine = (0, _react2.useMemo)(() => (0, _machine.createMachine)(machineProps), []);
  // We use the `step` prop to initialize the machine
  // After that we'll use `curStep` pulled from the machine's context
  const [currentState, send] = (0, _react.useMachine)(machine);
  const {
    curStep,
    steps
  } = currentState.context;

  // Find all steps with a clinical keyword answer
  const stepWithClinicalKeyword = (0, _find.default)(steps).call(steps, step => {
    var _context, _context2;
    return step?.controlType === _constants.uiControls.CLINICAL_SEARCH && ((_context = step?.searchQuery) == null ? void 0 : (0, _bind.default)(_context2 = Function.call).call(_context2, (0, _includes.default)(_context), _context))?.('clinical_keywords');
  });
  const renderSearchAltProviderButton = (0, _utils.shouldRenderSearchAltProviderButton)({
    currentState,
    searchMatchEnabled,
    stepWithClinicalKeyword
  });
  const handleChange = (0, _react2.useCallback)(_ref2 => {
    let {
      step,
      value,
      errors
    } = _ref2;
    if (!errors || !errors[0]) {
      send({
        type: ANSWER,
        data: {
          step,
          answer: value
        }
      });
    }
    // always trigger `onChange` to let the parent
    // adjust their state from "answered" to "answer has changed"
    onChange({
      errors,
      name,
      trackingData: step?.tracking
    });
  }, [onChange, send, name]);
  (0, _react2.useEffect)(() => {
    if (currentState.matches(done) || currentState.matches(warning) || currentState.matches(error) || currentState.matches(skipped)) {
      onDone({
        name,
        ctx: currentState.context,
        trackingData: curStep?.tracking,
        curState: currentState.value
      });
    }
  }, [currentState, curStep, name, onDone]);
  return /*#__PURE__*/_react2.default.createElement(_framerMotion.AnimatePresence, {
    initial: false,
    exitBeforeEnter: true
  }, /*#__PURE__*/_react2.default.createElement(_styles.Container, {
    "data-testid": "GxV2",
    className: className,
    isSkipped: currentState.matches(skipped)
  }, !currentState.matches(init) && (0, _map.default)(_context3 = (0, _filter.default)(steps).call(steps, s => !!s?.question)).call(_context3, step => /*#__PURE__*/_react2.default.createElement(_styles.Step, {
    key: `step-${step.id}`,
    variants: variants,
    initial: "initial",
    animate: "enter",
    exit: "exit"
  }, renderByControlType(curStep.flowId, currentState, step, handleChange, templateVariables, productName))), (0, _some.default)(_context4 = [pending, warning, error]).call(_context4, currentState.matches) && /*#__PURE__*/_react2.default.createElement(_styles.MessageWrapper, {
    key: currentState.value,
    variants: variants,
    initial: "initial",
    animate: "enter",
    exit: "exit"
  }, currentState.matches(pending) && /*#__PURE__*/_react2.default.createElement(_Loading.Loading, null), currentState.matches(warning) && /*#__PURE__*/_react2.default.createElement(_WarningBanner.WarningBanner, {
    message: curStep.message,
    templateVariables: templateVariables
  }), currentState.matches(error) && catchAllErrorBanner, renderSearchAltProviderButton && /*#__PURE__*/_react2.default.createElement(_SearchAltProviderButton.default, {
    clinicalKeyword: stepWithClinicalKeyword?.answer,
    track: track
  }))));
};
GxNext.propTypes = {
  csrfToken: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  onDone: _propTypes.func.isRequired,
  providerId: _propTypes.number.isRequired,
  steps: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.number.isRequired,
    flowId: _propTypes.number.isRequired,
    name: _propTypes.string.isRequired,
    nodeType: _propTypes.string.isRequired,
    question: _propTypes.string,
    control: _propTypes.object,
    controlType: _propTypes.string
  })),
  externalContext: (0, _propTypes.shape)({
    clinical_keyword: _propTypes.string,
    current_section: _propTypes.string,
    previous_answers: (0, _propTypes.arrayOf)({
      answer: _propTypes.string,
      node_id: _propTypes.number,
      protocol_id: _propTypes.number
    }),
    visit_method: _propTypes.string
  }),
  templateVariables: (0, _propTypes.shape)({
    phone_number: _propTypes.string.isRequired,
    provider_name: _propTypes.string.isRequired,
    provider_state: _propTypes.string.isRequired
  }),
  catchAllErrorBanner: _propTypes.node,
  className: _propTypes.string,
  config: _propTypes.object,
  // product name to pass as header to apis for analytical purposes
  productName: _propTypes.string,
  searchMatchEnabled: _propTypes.bool,
  track: _propTypes.func,
  machineProps: _propTypes.object
};
var _default = exports.default = GxNext;
GxNext.__docgenInfo = {
  "description": "Guide Experience (GX) renderer\n@param {string} csrfToken\n@param {string} providerId\n@param {string} name\n@param {Step[]} steps\n@param {ExternalContext} [externalContext]\n@param {function} onChange\n@param {function} onDone\n@param {JSX.Element} catchAllErrorBanner\n@param {string} [className]\n@param {object} [config]\n@param {string} [machineProps]\n@returns {JSX.Element}",
  "methods": [],
  "displayName": "GxNext",
  "props": {
    "machineProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "searchMatchEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "csrfToken": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "name": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onDone": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "providerId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "steps": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "number",
              "required": true
            },
            "flowId": {
              "name": "number",
              "required": true
            },
            "name": {
              "name": "string",
              "required": true
            },
            "nodeType": {
              "name": "string",
              "required": true
            },
            "question": {
              "name": "string",
              "required": false
            },
            "control": {
              "name": "object",
              "required": false
            },
            "controlType": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "externalContext": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "clinical_keyword": {
            "name": "string",
            "required": false
          },
          "current_section": {
            "name": "string",
            "required": false
          },
          "previous_answers": {
            "name": "arrayOf",
            "value": {
              "name": "custom",
              "raw": "{\n  answer: string,\n  node_id: number,\n  protocol_id: number\n}"
            },
            "required": false
          },
          "visit_method": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "templateVariables": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "phone_number": {
            "name": "string",
            "required": true
          },
          "provider_name": {
            "name": "string",
            "required": true
          },
          "provider_state": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": false
    },
    "catchAllErrorBanner": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "className": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "config": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "productName": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};